export default __webpack_public_path__ + "static/media/privacy.779864c4.png";